module.exports = global["jQuery"] = require("-!D:\\_yellowtree\\gizeh-website\\webroot\\typo3conf\\ext\\yt_gizeh\\Resources\\Private\\Sources\\node_modules\\expose-loader\\index.js?$!.\\jquery.js");


//////////////////
// WEBPACK FOOTER
// ../~/jquery/dist/jquery.js
// module id = 0
// module chunks = 0